export default "__VITE_ASSET__C2We7qGw__"